<div class="version-body">
  <div class="version-list" *ngIf="!creating">
    <div
      *ngFor="let version of versions; let i = index"
      class="version-item-holder">
      <div class="coin-display info-background">V{{ versions.length - i }}</div>
      <app-version-item
        [version]="version"
        (set_version)="versionService.setVersion($event)"
        (createFromVersion)="createFromVersion(version)"
        [active]="
          versionService?.currentVersion === version.id
        "></app-version-item>
    </div>
    <button
      pButton
      severity="primary"
      (click)="versionService.setVersion(null)"
      *ngIf="versionService.currentVersion">
      {{ 'version_return_to_create' | translation }}
    </button>
  </div>
  <div *ngIf="show_create">
    <div
      @input
      *ngIf="
        new_version &&
        !new_version.id &&
        !versionService.currentVersion &&
        creating
      ">
      <app-version-form [(version)]="new_version"></app-version-form>
      <button
        pButton
        severity="primary"
        (click)="createVersion(new_version)"
        [disabled]="!new_version.name || !new_version.description">
        {{ 'version_create' | translation }}
      </button>
    </div>
    <div class="align-center">
      <p-button
        @input
        ghost
        *ngIf="!creating"
        severity="info"
        (click)="setNewVersion()">
        <i class="fas fa-plus"></i> {{ 'version_new' | translation }}
      </p-button>
    </div>
  </div>
</div>
